import { SITUACAO } from "../types/SituacaoDocumento";

export const isIrregularDocument = (document) =>
  [
    SITUACAO.EXPIRADO,
    SITUACAO.EXPIRANDO,
    SITUACAO.RECUSADO,
    SITUACAO.UPLOAD_PENDENTE,
  ].includes(document.status) && !document.dispensado;
